import { createSlice } from "@reduxjs/toolkit";
import { analytics } from "../../firebase-config";

export const firebaseAnalytics = createSlice({
  name: "firebase analytics",
  initialState: { value: analytics },
  reducers: {
    enableAnalytics: () => {
      analytics.app._automaticDataCollectionEnabled = true;
      analytics.app._config.automaticDataCollectionEnabled = true;
      console.log(analytics);
    },
    disableAnalytics: () => {
      analytics.app._automaticDataCollectionEnabled = false;
      analytics.app._config.automaticDataCollectionEnabled = false;
      console.log(analytics);
    },
  },
});

export const { enableAnalytics, disableAnalytics } = firebaseAnalytics.actions;

export default firebaseAnalytics.reducer;
